import { render, staticRenderFns } from "./QuestionFile.vue?vue&type=template&id=79814129&scoped=true"
import script from "./QuestionFile.vue?vue&type=script&lang=js"
export * from "./QuestionFile.vue?vue&type=script&lang=js"
import style0 from "./QuestionFile.vue?vue&type=style&index=0&id=79814129&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79814129",
  null
  
)

export default component.exports